var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[(_vm.ready)?_c('v-col',[_c('FormsTable')],1):_vm._e()],1),_c('v-row',[(_vm.ready)?_c('v-col',[_c('FormsForm')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }